exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i);", ""]);

// module
exports.push([module.id, ".error {\n  display: flex;\n  justify-content: center;\n  align-items: inherit; }\n  .error-body {\n    font-family: \"Quicksand\", sans-serif;\n    font-size: 20px;\n    font-weight: 600;\n    text-align: center;\n    margin: 20px auto; }\n    .error-body span {\n      font-size: 26px;\n      display: block; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/containers/Error/Error.scss
// module id = 766
// module chunks = 0